export class pdfDisplay {
  src: string;
  title: string;

  constructor(props: any) {
    const { url, title } = props.pdf || {};

    this.src = url;
    this.title = title;
  }
}

export default pdfDisplay;
